import React, { memo, useMemo } from 'react';
import ThemeProvider from '@voltmoney/theme';
import { ColorTokens, IconSizeTokens, } from '@voltmoney/schema';
import { iconTokensMap } from './IconRegistry';
import { Pressable } from 'react-native';
const Icon = ({ id, name, size = IconSizeTokens.LG, color = ColorTokens.Primary_100, action, triggerAction, }) => {
    /**
     *  logic -> base-component(...props)
     * */
    const theme = ThemeProvider.getTheme();
    const Icon = useMemo(() => iconTokensMap[name], [name, size, color]);
    const icon_size = theme.iconSize[size];
    const icon_color = theme.colors[color];
    if (!name)
        return React.createElement(React.Fragment, null);
    const handleAction = () => {
        action &&
            triggerAction &&
            triggerAction(action);
    };
    if (action)
        return (React.createElement(Pressable, { hitSlop: { top: 48, bottom: 48, left: 48, right: 48 }, nativeID: id, onPress: handleAction, style: { padding: 10 } },
            React.createElement(Icon, { size: icon_size, color: icon_color })));
    return (React.createElement(Icon, { nativeID: id, size: icon_size, color: icon_color }));
};
export default memo(Icon);
export { Icon };
